import { TransportationConfigsByAgentIdItems, agentBankData, agentBankTypeData } from "services/interface";
import styled from "@emotion/styled";
import { Button, Col, Popconfirm, Row, Image, Select, Typography } from "antd";
import { FC } from "react";
import { CloseCircleOutlined } from "@ant-design/icons";
import noImage from "assets/images/no-image.png";

interface TypeItemsCardProps {
  data: agentBankTypeData;
  onDeleteData: (id: string) => void;
}

const TypeItemsCard: FC<TypeItemsCardProps> = ({ data, onDeleteData }) => {

  return (
    <FormWrapper>
      <Row>
        <Col span="12">
          <CardWrapper>
            <Typography.Text>
            {data.bank_type_name}
            </Typography.Text>
          <ButtonWrapper>
            <Popconfirm
                title="คุณต้องการลบประเภทบัญชี"
                description={
                  <Typography.Text>
                    คุณต้องการลบข้อมูลประเภทบัญชี
                    <br /> กดปุ่ม ยืนยัน เพื่อลบ
                  </Typography.Text>
                }
                okText="ยืนยัน"
                cancelText="กลับ"
                onConfirm={() => {
                  onDeleteData(data.bank_type_id);
                }}
              >
                <Button
                  size="small"
                  danger
                  icon={<CloseCircleOutlined />}
                >
                  ลบ
                </Button>
              </Popconfirm>           
            </ButtonWrapper>
          </CardWrapper>
        </Col>
      </Row>
    </FormWrapper>
  );
};

export default TypeItemsCard;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px 20px 2px 20px;
  background-color: #ffffffff;
`;

const ButtonWrapper = styled.div`
  display:flex;
  justify-content: flex-end;  
  width: 100%;
  height: 100%;
`;

const CardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0px 0px 0px 10px;
  background-color: #f5f5f5;
  white-space: nowrap;

border-radius: 8px;
transition: background-color 0.3s, box-shadow 0.3s;

&:hover {
  background-color: #ededed;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
`;

const OptionContent = styled.div`
display: flex;
align-items: center;
`;

const ImageWrapper = styled.div`
margin-right: 8px;
width: 20px;  
height: 20px; 
img {
  margin-top: -10px;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
`;
 